export type PrizmDocDemoNextVersion = '1.next' | '2.next' | '3.next';
export type PrizmDocDemoBetaVersion = '1.beta' | '2.beta' | '3.beta';
export type PrizmDocDemoMainVersion = '1' | '2' | '3';
export type PrizmDocDemoVersion = PrizmDocDemoMainVersion | PrizmDocDemoNextVersion | PrizmDocDemoBetaVersion;
